import {
  zhCN as cnLocale,
  enUS as enLocale,
  es as esLocale,
  fr as frLocale,
  Locale,
} from "date-fns/locale";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cnTranslations from "./locales/cn/translation.json";
import enTranslations from "./locales/en/translation.json";
import esTranslations from "./locales/es/translation.json";
import frTranslations from "./locales/fr/translation.json";
//See https://www.i18next.com/overview/configuration-options to config.

export type I18nKey = keyof typeof frTranslations;

export const LANGUAGES = ["en", "fr", "es", "cn"] as const;

export type Language = (typeof LANGUAGES)[number];

export const languageToLocale: Record<Language, Locale> = {
  fr: frLocale,
  en: enLocale,
  es: esLocale,
  cn: cnLocale,
};

const resources: Record<Language, { translations: typeof frTranslations }> = {
  fr: {
    translations: frTranslations,
  },
  en: {
    translations: enTranslations,
  },
  es: {
    translations: esTranslations,
  },
  cn: {
    translations: cnTranslations,
  },
};

i18n.use(initReactI18next).init({
  lng: "fr",
  resources,

  fallbackLng: LANGUAGES as unknown as string[],

  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
